
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class bankTypePopup extends Vue {
  popShow = false
  list = [
    { value: 1, label: '公司账户' },
    { value: 2, label: '私人账户' }
  ]

  showPop() {
    this.popShow = true
  }

  onSelect(data) {
    this.popShow = false
    this.$emit('confirm', data.value)
  }

  onCancel() {
    this.popShow = false
  }
}
